import { render } from "./MarketItem.vue?vue&type=template&id=1ae0bcce&scoped=true"
import script from "./MarketItem.vue?vue&type=script&lang=js"
export * from "./MarketItem.vue?vue&type=script&lang=js"

import "./MarketItem.vue?vue&type=style&index=0&id=1ae0bcce&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/wildwestgame/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae0bcce"]])

export default __exports__